import { MenuSeparator } from '../menu';

/**
 * DropdownMenuSeparator - visual separator between dropdown menu items
 *
 * Re-exports MenuSeparator for use within Dropdown.
 */
export function DropdownMenuSeparator() {
  return <MenuSeparator />;
}
